import React from "react";
import { css } from "@emotion/css";
import { Theme } from 'evcharging/app/themes';
import useTheme from "evcharging/hooks/useTheme";
import {assetUrl} from 'evcharging/services/cmsClient';
import Image from "next/image";

export const ServiceInfo = ({ serviceName, info, infoImg }) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.wrapper}>
      <div className={styles.root}>
        <div className={styles.image}>
          <Image src={assetUrl(infoImg)} alt={serviceName} width={495} height={495} />
        </div>
        <div>
          <div className={styles.heading}>
            {serviceName}
          </div>
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{__html: info}}
          />
        </div>
      </div>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  wrapper: css`
    max-width: 1280px;
    margin: auto;
    padding: 100px 15px 0;
  `,
  root: css`
    display: flex;
    gap: 136px;
    align-items: center;
    ${theme.breakpoints.mobile.down} {
      flex-wrap: wrap;
      gap: 32px;
      justify-content: center;
    }
  `,
  heading: css`
    color: #252C32;
    font-size: 32px;
    font-weight: 700;
    line-height: 130%;
    margin-bottom: 16px;
  `,
  text: css`
    color: #6E7C87;
    font-size: 16px;
    font-weight: 400;
    line-height: 160%;
  `,
  image: css`
    min-width: 495px;
    border-radius: 8px;
    overflow: hidden;
    ${theme.breakpoints.mobile.down} {
      min-width: auto;
    }
  `
});

export default ServiceInfo
